import service from '@/store/services/admin_calendar_settings-service';

const state = {
    holidaysList: {},
    holidaysDateList: {},
    createdHolidays: {},
    deletedHoliday: {},
    holidaysByDate: {}
};

const mutations = {
    SET_HOLIDAYS_LIST: (state, holidaysList) => {
        state.holidaysList = holidaysList;
    },
    SET_HOLIDAYS_DATE_LIST: (state, holidaysDateList) => {
        state.holidaysDateList = holidaysDateList;
    },
    SET_CREATED_DATE_LIST: (state, createNewHolidays) => {
        state.createdHolidays = createNewHolidays;
    },
    SET_DELETED_DATE_LIST: (state, deletedHoliday) => {
        state.deletedHoliday = deletedHoliday;
    },
    SET_HOLIDAYS_BY_DATE_LIST: (state, holidaysByDate) => {
        state.holidaysByDate = holidaysByDate;
    },
};

const actions = {
    holidaysList({dispatch, commit}, params) {
        return service.getHolidaysList(params).then(({holidaysList}) => {
            commit('SET_HOLIDAYS_LIST', holidaysList);
        });
    },
    holidaysDateList({dispatch, commit}, params) {
        return service.getHolidaysDateList(params).then(({holidaysDateList}) => {
            commit('SET_HOLIDAYS_DATE_LIST', holidaysDateList);
        });
    },
    createdHolidays({dispatch, commit}, params) {
        return service.createNewHolidays(params).then(({createNewHolidays}) => {
            commit('SET_CREATED_DATE_LIST', createNewHolidays);
        });
    },
    deletedHoliday({dispatch, commit}, params) {
        return service.deleteHoliday(params).then(({deletedHoliday}) => {
            commit('SET_DELETED_DATE_LIST', deletedHoliday);
        });
    },
    holidaysByDate({dispatch, commit}, params) {
        return service.getByDate(params).then(({holidaysByDate}) => {
            commit('SET_HOLIDAYS_BY_DATE_LIST', holidaysByDate);
        });
    },
};

const getters = {
    holidaysList: state => state.holidaysList,
    holidaysDateList: state => state.holidaysDateList,
    createdHolidays: state => state.createdHolidays,
    deletedHoliday: state => state.deletedHoliday,
    holidaysByDate: state => state.holidaysByDate,
};

const holidaySettings = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default holidaySettings;